export const appointmentStatusTypes = {
  completed: 'Completado',
  in_progress: 'En Progreso',
  not_started: 'Pendiente',
  cancelled: 'Cancelado',
};
